var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNorthernCyprus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h30v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#e30a17",
    d: "M14.07 15.2a6 6 0 1 1 0-6.4A4.79 4.79 0 0 0 5.7 12a4.8 4.8 0 0 0 8.37 3.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#e30a17",
    d: "M30 2H0v2h30z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e30a17",
    d: "M30 20H0v2h30z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e30a17",
    d: "m13.7 12 2.07-.67V9.15l1.28 1.76 2.08-.67L17.85 12l1.28 1.76-2.08-.67-1.28 1.76v-2.18z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorthernCyprus);
export default __webpack_public_path__ + "static/media/northern-cyprus.88708e8b76952051c8f7c9cd407080a9.svg";
export { ForwardRef as ReactComponent };